// src/store/ApiPara/selectors.js

// eslint-disable-next-line import/prefer-default-export
export const ApiParaSelector = ({ ApiParaData: { ApiPara } }) => ApiPara;
